import { FixaSelect } from "@coworker/apprestructured/src/shared/wrappers/FixaSelect/FixaSelect";

interface StoreSwitcherProps {
  label: string;
  activeStore: { storeId: string; name: string };
  stores: { storeId: string; name: string }[];
  handleSwitchStore: (storeId: string) => void;
}

const StoreSwitcher = ({
  label,
  activeStore,
  stores,
  handleSwitchStore,
}: StoreSwitcherProps) => (
  <FixaSelect
    id="store-selector"
    label={label}
    value={activeStore.storeId}
    onChange={(e) =>
      handleSwitchStore(encodeURIComponent(e.target.value as string))
    }
  >
    {stores?.map((store) => (
      <option key={store.storeId} value={store.storeId}>
        {store.storeId} - {store.name}
      </option>
    ))}
  </FixaSelect>
);

export default StoreSwitcher;
